export default __webpack_public_path__ + "static/media/gallery_04.37c0a95f.jpg";